import { render } from "./ForbiddenAccess.vue?vue&type=template&id=3615a8b3&scoped=true&ts=true"
import script from "./ForbiddenAccess.vue?vue&type=script&lang=ts"
export * from "./ForbiddenAccess.vue?vue&type=script&lang=ts"

import "./ForbiddenAccess.vue?vue&type=style&index=0&id=3615a8b3&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3615a8b3"]])

export default __exports__